import axios from "axios";
import { VITE_BASE_URL } from "@/env";
import { getIdentificationData } from "./identification.utils";

const { token } = getIdentificationData();

const buildRedirectUrl = () => {
  if (location.origin.includes("dpxpre")) {
    return "/fotos-componentes-pre-api";
  }
  return "/fotos-componentes-api";
};

export const BASE_URL_API = `${VITE_BASE_URL}${location.origin.includes("dpx") ? buildRedirectUrl() : ""}`;

const api = axios.create({
  baseURL: `${BASE_URL_API}/api/v1/`,
  headers: {
    "Content-Type": "application/json",
    Authorization: token,
  },
});

export default api;
